/**
 * Create products name slider
 */
function createProductsNameSlider() {
    $('.slider-products-name').slick({
        centerMode: true,
        centerPadding: 0,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        arrows: true,
        asNavFor: '.slider-products-image, .slider-products-description'
    });
}

/**
 * Create products image slider
 */
function createProductsImageSlider() {
    $('.slider-products-image').slick({
        centerMode: true,
        centerPadding: 0,
        slidesToShow: 5,
        autoplay: false,
        arrows: false,
        asNavFor: '.slider-products-name, .slider-products-description'
    });
}

/**
 * Create products description slider
 */
function createProductsDescriptionSlider() {
    $('.slider-products-description').slick({
        accessibility: false,
        centerMode: true,
        centerPadding: 0,
        slidesToShow: 1,
        autoplay: false,
        arrows: false,
        asNavFor: '.slider-products-image, .slider-products-name'
    });
}

/**
 * Create partners slider
 */
function createPartnersSlider() {
    $('.slider-partners').slick({
        slidesToShow: 6,
        autoplay: true,
        arrows: false
    });
}


/**
 * Export function
 */
export {
    createProductsNameSlider,
    createProductsImageSlider,
    createProductsDescriptionSlider,
    createPartnersSlider
}
